// @ts-ignore
import SwaggerClient from "swagger-client";
import {config} from "../config";

export let apiClient: SwaggerClient = undefined;
export let sessionId: string = "";

export const loadApi = async () => {
    return new SwaggerClient({
        url: config.get("backend") + "swagger.json?server=" + config.get("backend"),
        withCredentials: true,
        requestInterceptor: (req: any) => {
            if (sessionId && !req.url.endsWith("/auth/check")) req.headers.Session = sessionId;
            req.headers.Authorization = req.headers.Authorization || config.get("token");
        },
        responseInterceptor: (res: any) => {
            if (res.headers.session) {
                sessionId = res.headers.session;
            }
        }
    }).then((client: any) => {
        apiClient = client;
        return client;
    });
};
